export const BRAND_TITLE = "滴答滴答延迟监控";
export const BRAND_TAGLINE = "线路延迟与节点状态";
